"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecodeWarningType = void 0;
var DecodeWarningType;
(function (DecodeWarningType) {
    DecodeWarningType["UnknownTypeCode"] = "allegro-decode-unknown-typecode";
    DecodeWarningType["UnrecognizedShape"] = "allegro-decode-unrecognized-shape";
    DecodeWarningType["CrossRefMiss"] = "allegro-decode-cross-ref-miss";
    DecodeWarningType["InvariantViolation"] = "allegro-decode-invariant-violation";
})(DecodeWarningType || (exports.DecodeWarningType = DecodeWarningType = {}));
//# sourceMappingURL=decoded-types.js.map